import React from 'react';
import './TopBar.css';
import { useTranslation } from 'react-i18next';
import { handleExportToPDF } from './handleExportToPDF'; // Standard PDF export
import { handleExportToPDFArabic } from './handleExportToPDFArabic'; // Arabic PDF export

function TopBar({ chatHistoryRef, messages }) {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "arabic"; // Check if Arabic is selected
    console.log(i18n.language);
    return (
        <div className="top-bar">
            <div className="export-button-container">
                <button
                    className="export-button"
                    onClick={() =>
                        isArabic
                            ? handleExportToPDFArabic(messages, t, i18n)
                            : handleExportToPDF(messages, t, i18n)
                    }
                >
                    {t("chat.export")}
                </button>
            </div>
        </div>
    );
}

export default TopBar;
